module.exports = __webpack_public_path__ + "img/CC2023.3c1a56ab.png";